<div class="grid-expandable" [class.is-expanded]="this.isExpanded()">
  @if (this.isExpanded()) {
    <div class="grid-expandable__backdrop" (click)="this.collapse()"></div>
  }
  <div class="grid-expandable__panel">
    <div class="grid-expandable__header">
      <div class="grid-expandable__controls">
        <ng-content select="[controls]"></ng-content>
      </div>
    </div>
    <div class="grid-expandable__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
